import React from "react";
import { LegalLink } from "@/components/Legal";
import { PHONE, EMAIL, INSTAGRAM_URL, INSTAGRAM_HANDLE, LOGO_LIGHT, scrollToId } from "@/lib/scroll";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="relative overflow-hidden bg-navy-deep text-white">
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-12 md:py-20">
        <div className="flex flex-col items-start gap-10 md:flex-row md:items-center md:justify-between">
          <button onClick={() => scrollToId("hero")} className="text-left" data-testid="footer-logo">
            <img src={LOGO_LIGHT} alt="Alba Selection" className="h-28 w-auto md:h-32" />
          </button>
          <button
            data-testid="footer-cta"
            onClick={() => scrollToId("contatti")}
            className="rounded-full bg-gold px-7 py-3.5 font-display text-sm font-semibold text-navy-deep transition-colors duration-300 hover:bg-amber hover:text-white"
          >
            Richiedi l'analisi gratuita
          </button>
        </div>

        <div className="mt-14 h-px w-full bg-white/10" />

        <div className="mt-10 grid grid-cols-1 gap-6 text-sm text-white/60 md:grid-cols-2">
          <div className="space-y-1.5">
            <p className="font-medium text-white">Alba Selection — Seim Multiservice di Bascià Alessandro</p>
            <p>
              P.IVA 05030160757 · {PHONE} ·{" "}
              <a href={`mailto:${EMAIL}`} className="transition-colors hover:text-gold">{EMAIL}</a>
            </p>
            <p className="text-white/45">
              A cura di Alba Selection · Revenue Management &amp; Gestione Affitti Brevi · Salento
            </p>
          </div>
          <div className="flex flex-wrap items-start gap-x-6 gap-y-2 md:justify-end">
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="transition-colors hover:text-gold"
            >
              Instagram {INSTAGRAM_HANDLE}
            </a>
            <LegalLink type="privacy" testId="footer-privacy" className="transition-colors hover:text-gold" />
            <LegalLink type="cookie" testId="footer-cookie" className="transition-colors hover:text-gold" />
          </div>
        </div>

        <p className="mt-10 text-xs text-white/40">
          © {year} Alba Selection — Tutti i diritti riservati
        </p>
      </div>
    </footer>
  );
};
